import React from 'react';
import { Link as ReactRouterLink, useLocation } from 'react-router-dom';
import { Text, Link } from '@resideo/blueprint-react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { PRO_PORTAL_URL, SHOPIFY_STORE_LOGIN_URL } from '../../config';
import { ADD_DISTRIBUTOR_OPTION_USER_TYPE } from 'config/flags';
import { useAuth0 } from '@auth0/auth0-react';
import useReturnToUrl from 'hooks/useReturnToUrl';

const linkStyle = css`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.primary};
`;

const NavLink = styled(Link)`
  ${linkStyle}
`;

const SignInLink = () => {
  const { t } = useTranslation();
  const { loginWithRedirect } = useAuth0();
  const { SignInURL } = useReturnToUrl();
  const handleSignIn = () => {
    loginWithRedirect({
      prompt: 'login',
      appState: { returnTo: SignInURL() },
    });
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // In-app webview: render nothing
  if (searchParams.get('isInAppWebview') === 'true') {
    return null;
  }

  // Shopify distributor workflow: link directly to Shopify to bypass MyID
  const isShopifyWorkflow =
    ADD_DISTRIBUTOR_OPTION_USER_TYPE &&
    searchParams.get('userType') === 'distributor' &&
    !!SHOPIFY_STORE_LOGIN_URL;

  if (isShopifyWorkflow) {
    return (
      <Text textAlign='center'>
        {t('signUp.company.alreadyHaveAccount')}&nbsp;
        <NavLink data-test-sign-in-link href={SHOPIFY_STORE_LOGIN_URL}>
          {t('signUp.backToSignIn')}
        </NavLink>
      </Text>
    );
  }

  // Only when the user clicked on Invite link and reached company application form, sign-in link is updated
  if (location.pathname === '/sign-up' && location.search.includes('invite')) {
    return (
      <Text textAlign='center'>
        {t('signUp.company.alreadyHaveAccount')}&nbsp;
        <NavLink
          as={ReactRouterLink}
          data-test-sign-in-link
          to={`${PRO_PORTAL_URL}/sign-up/accept-invite${location.search}`}>
          {t('common.signIn')}
        </NavLink>
      </Text>
    );
  }

  return (
    <Text textAlign='center'>
      {t('signUp.company.alreadyHaveAccount')}&nbsp;
      <NavLink data-test-sign-in-link onClick={handleSignIn}>
        {t('common.signIn')}
      </NavLink>
    </Text>
  );
};

export default SignInLink;
